import { render, staticRenderFns } from "./material-template-detail.vue?vue&type=template&id=6e9ff3e6&scoped=true"
import script from "./material-template-detail.vue?vue&type=script&lang=js"
export * from "./material-template-detail.vue?vue&type=script&lang=js"
import style0 from "./material-template-detail.vue?vue&type=style&index=0&id=6e9ff3e6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9ff3e6",
  null
  
)

export default component.exports